import { publicFallback } from "@app/.core/AppRoutes";
import { authorizedRoutes } from "@app/.core/AppRoutes/AuthorizedRoutes";
import { useTypedSelector } from "@lib/redux";
import { AuthRoles } from "@lib/types/Auth";
import { useMemo } from "react";
import { Navigate } from "react-router-dom";

export default function RouterComponent() {
  const { isAuthenticated, user } = useTypedSelector((state) => state.auth);

  const fallback = useMemo(() => {
    if (isAuthenticated) {
      const find = authorizedRoutes
        .filter((f) => {
          if (user?.role === AuthRoles.Admin) {
            return !!f?.isManagement === !!user?.isManagement;
          }
          return true;
        })
        .find((f) => f.roles?.includes(user?.role));
      if (find) {
        if (typeof find.path === "string") {
          return find.path;
        }
        if (Array.isArray(find.path)) {
          return find.path[0];
        }
      }
      return "/error-pages/error-404";
    }

    return publicFallback;
  }, [isAuthenticated, user]);

  return <Navigate to={fallback} replace />;
}
